import { Descriptions } from 'antd';
import type { ReactNode } from 'react';

/** Label/value facts for a record page (Ant Descriptions); rows keep the legacy class so tests can target them. */
export function RecordFacts({ items, columns = 2 }: { items: [string, ReactNode][]; columns?: 1 | 2 | 3 }) {
  return (
    <Descriptions
      className="record-facts"
      size="small"
      bordered
      column={{ xs: 1, sm: 1, md: columns, lg: columns, xl: columns, xxl: columns }}
      items={items.map(([label, value]) => ({ key: label, label, children: <span className="settings-row-value">{value}</span> }))}
    />
  );
}
